import React, { useState, useEffect } from 'react';
import {
  Button,
  Label,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from 'reactstrap';

/**
 * Modal to create or edit a brand
 */
function BrandModal({
  title = 'Marca',
  isOpen = false,
  onToggle = () => {},
  defaultBrand = null,
  onSubmit = () => {},
}) {
  const [name, setName] = useState('');

  // Update form when defaultBrand changes (for edit mode)
  useEffect(() => {
    if (defaultBrand) {
      setName(defaultBrand.name || '');
    } else {
      setName('');
    }
  }, [defaultBrand]);

  const handleSubmit = () => {
    if (!name.trim()) return;
    onSubmit(name.trim());
    handleCancel(); // Close modal and reset form
  };

  const handleCancel = () => {
    // Reset form to original values
    if (defaultBrand) {
      setName(defaultBrand.name || '');
    } else {
      setName('');
    }
    onToggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={onToggle} size="md">
      <ModalHeader toggle={onToggle}>{title}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="brandName">Nombre de la marca</Label>
          <Input
            id="brandName"
            type="text"
            placeholder="Ingrese el nombre de la marca"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSubmit();
              }
            }}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleCancel}>
          Cancelar
        </Button>
        <Button color="primary" onClick={handleSubmit} disabled={!name.trim()}>
          {defaultBrand ? 'Actualizar' : 'Crear'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default BrandModal;
